/***
 * Created on 2023/9/18
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useMutation, useQuery} from "@tanstack/react-query";
import {apiGet, apiPost} from "../../../service/api";
import {useTogglePopup} from "../../../hook/toggle_popup";
import {useOnChange} from "../../../hook/form";
import {useCountdown} from "../../common/countdown";
import AddPhoneWizardStep2 from "./add_phone_wizard_step2";


function AddPhoneWizard({...props}) {
    const { t } = useTranslation();
    const lang = localStorage.getItem('currentLang');
    const {isShow, toggleAction, elemRef} = useTogglePopup();
    const [country, setCountry] = useState();
    const {seconds, setSeconds} = useCountdown(0);
    const [sent, setSent] = useState(false);
    const modalRef = useRef();
    const {values, setValues, onChange} = useOnChange({
        country_code: '',
        number: '',
        code: ''
    })

    useQuery({
        queryKey: ['get_countdown'],
        queryFn: async () => {
            const data = await apiGet('/ajax/countdown')
            const now = new Date().getTime();
            const value = Math.round((now - data?.countdown) / 1000) || 0;
            setSeconds(value > 60 ? 0 : 60 - value);
            return data;
        }
    });

    const country_code = useQuery({
        queryKey: ['get_country_code'],
        queryFn: async () => await apiGet('/ajax/country_code')
    });

    const sendMobileCode = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/send_mobile_code', data),
        onSuccess: data => {
            setSeconds(60);
            setSent(true);
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const onSelectCountry = (country) => {
        setValues(prev => {
            return {
                ...prev,
                country_code: `+${country.country_code}`
            }
        });
        setCountry(country);
    }

    const onSendMobile = async () => {
        await sendMobileCode.mutateAsync({
            country_code: values.country_code,
            mobile_number: values.number,
            lang
        });
    }

    useEffect(() => {
        if (modalRef?.current) {
            if (seconds > 0 || !values?.country_code || !values?.number) {
                modalRef.current.disableSubmitButton(true);
                modalRef.current.updateSubmitText(`${t('@Next@')} ${seconds > 0 ? '(' + seconds + ')' : ''}`);
            } else {
                modalRef.current.disableSubmitButton(false);
            }
        }
    }, [seconds, values.country_code, values.number]);

    return (
        <>
            {!sent &&
                <ModalDialog {...props} title={t('@Add phone number@')}
                             submitText={t('@Next@')}
                             submitAction={onSendMobile}
                             ref={modalRef}>
                    <div className="dialog-content">
                        <div className="dialog__form-group">
                            <label>{t('@Phone number@')}</label>
                            <div className="comp-input">
                                <div className="input-field--hybrid">
                                    <div className={`comp-select ${isShow ? 'active' : ''}`} ref={elemRef} onClick={toggleAction}>
                                        <div className="q-select cursor-pointer">
                                            <div className="q-select__label">{country?.country}({country?.country_code})
                                            </div>
                                            <div className="q-select__arrow"></div>
                                        </div>
                                        <div className="comp-dropdown" data-modal-sheet>
                                            <ul className="dropdown-menu">
                                                <li className="dropdown-menu-section">
                                                    {
                                                        country_code?.data && country_code.data.map(country =>
                                                            <div className="dropdown-menu__item cursor-pointer"
                                                                 key={country._id}
                                                                 onClick={() => onSelectCountry(country)}>{country.country}(+{country.country_code})</div>
                                                        )
                                                    }
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <input type="text" name="number" inputMode={"numeric"} value={values.number} onChange={onChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalDialog>
            }

            { sent &&
                <AddPhoneWizardStep2 {...props}
                    country_code={country_code}
                    country={country}
                    onChange={onChange}
                    onSelectCountry={onSelectCountry}
                    seconds={seconds}
                    values={values}
                    onSendMobile={onSendMobile}/>
            }
        </>
    );
}

export default AddPhoneWizard;